/**
 * Public API Surface of EnterpriseLogsApi functions
 */

export * from './get-log-search';
export * from './post-log-search';
